import { Routes } from '@angular/router';
import {
  ErrorPageComponent,
  ForbiddenPageComponent,
  NotFoundPageComponent,
  UnauthorizedPageComponent,
} from '@remedeelabs/surveys-common';

export const appRoutes: Routes = [
  {
    path: 'therapeutic-survey',
    loadChildren: () => import('./therapeutic-survey.routes'),
  },
  {
    path: 'survey',
    loadChildren: () => import('./survey.routes'),
  },
  {
    path: 'survey/ide',
    loadChildren: () => import('./ide.routes'),
  },
  {
    path: 'tracking-sheet',
    loadChildren: () => import('./tracking-sheet.routes'),
  },
  {
    path: 'custom-survey',
    loadChildren: () => import('./custom-survey.routes'),
  },
  {
    path: 'evaluate-survey',
    loadChildren: () => import('./evaluate-survey.routes'),
  },

  { path: 'error', component: ErrorPageComponent },
  { path: 'unauthorized', component: UnauthorizedPageComponent },
  { path: 'forbidden', component: ForbiddenPageComponent },
  // must be last!
  { path: '**', component: NotFoundPageComponent },
];
